import config from '@/config'

const urls = {
  single: 'app',
  multiple: 'apps',
}

const resourceUrl = `${config.resourceHost}extensions/`
const developerUrl = `${resourceUrl}developer`
const marketplaceUrl = `${resourceUrl}marketplace`

const STATUS_DEVELOPMENT = 'inDevelopment'
const STATUS_PENDING = 'pending'
const STATUS_REVIEW = 'inReview'
const STATUS_REJECTED = 'rejected'
const STATUS_APPROVED = 'approved'

export default {
  resourceUrl,
  global: config,

  routes: {
    details: `/${urls.single}/`,
    list: `/${urls.multiple}`,
    setup: `/${urls.multiple}/setup`,
  },

  api: {
    developer: developerUrl,
    developerApps: `${developerUrl}/apps`,
    apps: `${marketplaceUrl}/apps`,
    create: `${developerUrl}/app`,
    app: (id, version) => `${developerUrl}/app/${id}/${version}`,
    scopes: `${developerUrl}/scopes`,
    files: `${developerUrl}/files`,
    developerById: id => `${developerUrl}/byId/${id}`,
    publish: (id, version) => `${developerUrl}/app/publish/${id}/${version}`,
    developers: `${developerUrl}/list`,
    appDetail: id => `${marketplaceUrl}/apps/${id}`,
    install: id => `${marketplaceUrl}/apps/${id}/install`,
    uninstall: id => `${marketplaceUrl}/apps/${id}/uninstall`,
    resetAppData: id => `${marketplaceUrl}/apps/${id}/resetAppData`,
    isInstalled: id => `${marketplaceUrl}/apps/${id}/installed`,
    ownership: id => `${marketplaceUrl}/ownership/${id}/update`,
    installedApps: `${marketplaceUrl}/installedApps`,
  },

  status: {
    STATUS_DEVELOPMENT, STATUS_PENDING, STATUS_REVIEW, STATUS_REJECTED, STATUS_APPROVED,
  },
}
